import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8" }
const _hoisted_2 = { class: "inline-block min-w-full py-2 align-middle md:px-6 lg:px-8" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Item")
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = { class: "font-semibold text-gray-900 whitespace-nowrap" }
const _hoisted_6 = { class: "text-gray-600" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Price")
const _hoisted_8 = { class: "text-gray-600 whitespace-nowrap" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Status")
const _hoisted_10 = { class: "text-gray-500 whitespace-nowrap" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Shipment")
const _hoisted_12 = { class: "text-gray-600 whitespace-nowrap" }

import { useOrders } from "@/composables/orders";
import { computed, PropType, ref } from "vue";
import DefaultTable from "@/components/DefaultTable.vue";
import OrderStatusBadge from "@/components/OrderStatusBadge.vue";
import { formatDistanceToNow, parseISO } from "date-fns";
import { CheckIcon } from "@heroicons/vue/solid";
import Checkbox from "@/components/Checkbox.vue";
import { indexOf, orderBy, pick, some, sortBy } from "lodash";
import { IOrder } from "@/utils/IOrder";
import Button from "@/components/Button.vue";


export default /*#__PURE__*/_defineComponent({
  props: {},
  emits: ["update:selected"],
  setup(__props, { emit }) {

const props = __props





const { orders: allOrders } = useOrders();

const customOrder = ["FULFILLED", "CANCELLED", "RELEASED", "ORDERED", "HOLD"];

const orders = computed(() =>
  orderBy(
    allOrders.value,
    [(o) => indexOf(customOrder, o.status), (o) => o.statusLastUpdatedAt],
    ["desc", "desc"]
  )
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DefaultTable, {
        columns: ['name', 'cost', 'status', 'time', 'shipment'],
        rows: _unref(orders)
      }, {
        "th-name": _withCtx(() => [
          _hoisted_3
        ]),
        "td-name": _withCtx(({ row: order }) => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(order.name), 1),
            _createElementVNode("span", _hoisted_6, _toDisplayString(order.supplier) + " " + _toDisplayString(order.origin) + " " + _toDisplayString(order.supplierRef), 1)
          ])
        ]),
        "th-cost": _withCtx(() => [
          _hoisted_7
        ]),
        "td-cost": _withCtx(({ row: order }) => [
          _createElementVNode("span", _hoisted_8, " $" + _toDisplayString(order.costPriceUsd) + " USD ", 1)
        ]),
        "th-status": _withCtx(() => [
          _hoisted_9
        ]),
        "td-status": _withCtx(({ row: order }) => [
          _createVNode(OrderStatusBadge, {
            value: order.status
          }, null, 8, ["value"])
        ]),
        "td-time": _withCtx(({ row: order }) => [
          _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(formatDistanceToNow)(_unref(parseISO)(order.statusLastUpdatedAt), {
                addSuffix: true,
              })), 1)
        ]),
        "th-shipment": _withCtx(() => [
          _hoisted_11
        ]),
        "td-shipment": _withCtx(({ row: order }) => [
          _createElementVNode("span", _hoisted_12, _toDisplayString(order.trackingRef?.join(", ")), 1)
        ]),
        _: 1
      }, 8, ["rows"])
    ])
  ]))
}
}

})